<template>
  <div></div>
</template>

<script>
export default {
  name: 'Copyright'
}
</script>

<style lang="scss" module></style>
